import { getDefaultFilterDate } from '../../transactions/utils';

export const getFilterRangeQuery = (filterYearValue: number) => {
  if (filterYearValue) {
    return `endTime=${filterYearValue}-12-31&startTime=${filterYearValue}-01-01`;
  }
  const { max, min } = getDefaultFilterDate();
  return `endTime=${max.toISOString().substring(0, 10)}&startTime=${min.toISOString().substring(0, 10)}`;
};

export const getFilterRangeQueryV2 = (filterYearValue: number) => {
  if (filterYearValue) {
    return {
      endTime: `${filterYearValue}-12-31`,
      startTime: `${filterYearValue}-01-01`,
    };
  }
  const { max, min } = getDefaultFilterDate();
  return {
    endTime: `${max.toISOString().substring(0, 10)}`,
    startTime: `${min.toISOString().substring(0, 10)}`,
  };
};
